import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { WARootState } from '@/store/store';
import { useModuleAccess } from '@/permissions';

const useCanInviteInvestor = (): boolean => {
  const currentRole = useSelector((s: WARootState) => s.auth.currentRole);
  const { validateByModule, validateByCode } = useModuleAccess();

  return useMemo(() => {
    const role = (currentRole || '').toLowerCase();
    if (role === 'advisor' || role === 'business banker') {
      return (
        validateByModule('AdvisorSetup') && validateByCode('CanInviteClients')
      );
    }
    if (role === 'firm' || role === 'commercial firm') {
      return (
        validateByModule('AdvisorSetup') &&
        validateByCode('CanSeeClientInformation')
      );
    }
    return false;
  }, [currentRole, validateByModule, validateByCode]);
};

export default useCanInviteInvestor;
